var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileSwipeUpOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 7,
  viewBox: "0 0 18 7",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.51 6.872a1 1 0 0 0 .98-1.744l-8-4.5a1 1 0 0 0-.98 0l-8 4.5a1 1 0 0 0 .98 1.744L9 2.647z"
})));
export default SvgInstagramMobileSwipeUpOutline;